<!--
Author: TangChen
Date: 2019-01-03
Desc: 购买定投基金，由index.js 配置引入
-->
<template>
    <div :class="'bizcomp-general-buy bizcomp ' + className">
        <comp-title :title="title">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/gfund' }">
                    基金定投
                </el-breadcrumb-item>
                <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title>
        <plan-buy v-if="fund.fundcode" :general-fund="fund" />
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import planBuy from "@/components/fund/planBuy";
export default {
    name: "GeneralBuy",
    components: {
        planBuy
    },
    mixins: [mixin],
    data () {
        return {
            fund: {}
        };
    },
    mounted () {
        this.fund = JSON.parse(sessionStorage.getItem(this.$route.name));
    },
    methods: {
    }
};
</script>
<style lang="scss">
  @import '../../assets/css/varibles';
  .bizcomp-general-buy {
    padding-bottom: 30px;
  }
</style>
